import { Power1, TimelineMax } from "gsap";
import { CreateElement, Scale, Size } from "../../.././MyHelpers";
import { BigSymbolFreegamesCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { CanvasSprite } from "../../../slot/Sprite/CanvasSprite";
import { ZIndex } from "../../../ZIndex";
import { MyCanvas } from "../../MyCanvas";
import { BigSymbolFreegames2, BigSymbolFreegames2Factory } from "./BigSymbolFreegames2";
import { BigSymbolFreegames2Params } from "./BigSymbolFreegames2Params";
export class BigSymbolFreeGames2_2Screen extends BigSymbolFreegames2{
    //protected fontHeight:number=Scale.fh(100);
    public constructor(gameResid: ResourceIdentifier, params: BigSymbolFreegames2Params, config: BigSymbolFreegamesCommonConfiguration) {
        super(gameResid,params,config);
		this.fontHeightWinCount = Scale.fh(110);
    }

    public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
        await super.ResourcesLoaded(loadingStage, resourceManager);

    }

    protected override FreeGameTitleSprite(resourceManager:ResourceManager)
	{

		this.TitleBonus = CreateElement("div", {
			classes: [this.resid.Scope() + "-game-title"],
			parentToAppend:this.view,
			style: {
				position: "absolute",
				width: Scale.Wpx(762),
				height: Scale.Hpx(180),
				top: Scale.Ypx(454),
				left:Scale.Xpx(110),
				display: "flex",
				justifyContent: "center",
				alignContent: "center",
				zIndex:ZIndex.HoldAndStopTitle.toString(),
				backgroundPosition:"center",
				backgroundSize:"contain",
				backgroundRepeat:"no-repeat",
			}
		});

		this.TitleFreeGameSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("FreeGameTitleBounce")).sprite, canvasSize: new Size(Scale.W(762),Scale.H(180))});
		this.TitleFreeGameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("BounceSound")));
		this.TitleBonus.appendChild(this.TitleFreeGameSprite.View());
	
	}

    protected override FreeGameStatsLeft()
	{
		super.FreeGameStatsLeft();
		//MOVE STATS LEFT
		this.freegameStats.style.top=Scale.Xpx(530);
		this.freegameStats.style.left = Scale.Xpx(30);
			
    }

    protected override FreeGameStatsRight(){
		super.FreeGameStatsRight();
		//MOVE STATS RIGHT
        this.freegameStats2.style.top=Scale.Xpx(530);
		this.freegameStats2.style.left=Scale.Xpx(530);
		this.freegameStats2.style.right=Scale.Xpx(0); 

		this.TotalPlayed.style.top=Scale.Ypx(63);
	  }


    protected override SpinsRemainingSprite(resourceManager:ResourceManager)
	{
		// super.SpinsRemainingSprite(resourceManager);
		this.spinsRemainingBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(436), Scale.H(330))});
		this.spinsRemainingBackgroundSprite.Start(true);
		this.spinsRemainingBackgroundSprite.View().style.position="absolute";
		this.spinsRemainingBackgroundSprite.View().style.left=Scale.Xpx(-10);
		this.spinsRemainingBackgroundSprite.View().style.top=Scale.Ypx(47);
		this.freegameStats.appendChild(this.spinsRemainingBackgroundSprite.View());

	}

	protected override SpinsPlayedSprite(resourceManager:ResourceManager)
	{
		// super.SpinsPlayedSprite(resourceManager);
		this.spinsPlayedBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(436), Scale.W(330))});
		this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.position="absolute";
		this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.left=Scale.Xpx(-10);
		this.spinsPlayedBackgroundSprite.View().style.top=Scale.Ypx(47);
		this.freegameStats2.appendChild(this.spinsPlayedBackgroundSprite.View());
		
    }
    

    protected override PlayedCountAnimation()
	{
		super.PlayedCountAnimation();
   
    }

    protected override CanvaswinCount(resourceManager:ResourceManager)
	{
        super.CanvaswinCount(resourceManager);
     		
		
    }

    protected override WinFrameLoaded(resourceManager: IReadOnlyResourceManager)
	{

		super.WinFrameLoaded(resourceManager);		
	
		this.winContainer.style.position = "absolute";
		this.winContainer.style.top =Scale.Ypx(814);
		this.winContainer.style.left = Scale.Xpx(120);
		this.winContainer.style.width = Scale.Wpx(817);
		this.winContainer.style.height = Scale.Hpx(185);
		// this.winContainer.style.display ="none";			

		this.BackgroundContainer.style.width = Scale.Wpx(817);
		this.BackgroundContainer.style.height = Scale.Hpx(185);
		this.BackgroundContainer.style.top = Scale.Ypx(5);
		this.BackgroundContainer.style.left = Scale.Xpx(20);
		
	}

	protected override CreateSpriteContainer(resourceManager:ResourceManager)
	{
		//CHANGE TO SPRITE 
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
		this.FrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(860), Scale.H(250))});
		//this.FrameSprite.ScaleNonUniform(1,1.3);
		//this.FrameSprite.View().style.zIndex="4";
		this.FrameSprite.View().style.position="absolute";
		this.FrameSprite.View().style.top= Scale.Ypx(-28);
		//this.FrameSprite.View().style.display="none";
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		
	
		// this.WinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(860), Scale.H(250)), this.fontHeight,  this.resid.ScopedResourceName("bigwincount"));
		// //this.WinCountAnimation.View().style.top="13px";
		// //let countView = this.WinCountAnimation.View();
		// this.WinCountAnimation.View().style.position = "relative";
		// this.WinCountAnimation.View().style.top =Scale.Ypx(-28);
		// this.WinCountAnimation.View().style.left = Scale.Xpx(32);
		// this.WinCountAnimation.View().style.width = Scale.Wpx(860);
		// this.WinCountAnimation.View().style.pointerEvents = "none";
		// this.winContainer.appendChild(this.WinCountAnimation.View());
		//this.FrameSprite.View().appendChild(countView);
		this.winContainer.appendChild(this.FrameSprite.View());
	}
    
    protected override BonusWinLoaded(resourceManager:ResourceManager)
	{
		this.BonusWinSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("BonusTitleBigSymbolFreegames")).sprite, canvasSize: new Size(Scale.W(762), Scale.H(180))});
        //this.TitleFreeGameSprite.Start(true);
        
		this.BonusWinSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("BounceSound")));
		this.BonusWinSprite.View().style.display="none";
        this.BonusWinSprite.View().style.top=Scale.Ypx(656);
        this.BonusWinSprite.View().style.left=Scale.Xpx(269);
        this.BonusWinSprite.View().style.position="absolute";
		
		this.WinAllContainer.appendChild(this.BonusWinSprite.View());
		this.BounceAnim = new TimelineMax({
			paused: true,
			repeat: -1,
		});

		this.BounceAnim

			/* ball bounce up */
			.fromTo(this.BonusWinSprite.View(), 0.5, {

				y: Scale.X(0),

			}, {
				y: Scale.Y(-70),
				ease: Power1.easeOut, transformOrigin: "50% 50%",
			}
				, "bounce")

			/* ball bounce down */
			.to(this.BonusWinSprite.View(), 0.4, {
				transformOrigin: "50% 50%",
				y: Scale.Y(0),
				ease: Power1.easeIn
				//ease: Power1.easeInOut
			}, "bounce2")

			/* ball squash */
			.to(this.BonusWinSprite.View(), 0.35, {
				transformOrigin: "50% 100%",
				//scaleX: Scale.X(1),
				scaleY: 0.30,
				ease: Power1.easeInOut
				//ease: Bounce.easeOut
			}, "bounce3")

			.to(this.BonusWinSprite.View(), 0.35, {
				transformOrigin: "100% 100%",
				//scaleX: Scale.X(1),
				scaleY: 1,
				ease: Power1.easeInOut,
				}, "bouncefinal");

    }
    
    protected override CanvaswinCountShow(resourceManager: ResourceManager) {
		
		this.WinCanvasShow = new MyCanvas(new Size(Scale.W(817), Scale.H(185)), {
            style: {
                left: Scale.Xpx(14),
                position: "absolute",
                alignItems: "center",
                justifyContent: "center",
                zIndex: "" + ZIndex.BonusWin,
				top : Scale.Xpx(16),
            }
        });	

		this.winContainer.appendChild(this.WinCanvasShow.View());
	}
   
}

export class BigSymbolFreegames2Factory_2Screen extends BigSymbolFreegames2Factory {

	public CreateBigSymbolFreegames2_2Screen(gameName: ResourceIdentifier, params: BigSymbolFreegames2Params, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegames2 {
		return new BigSymbolFreeGames2_2Screen(gameName, params, config);
	}
}
